import { render } from "./MyDatabaseGraph.vue?vue&type=template&id=cdb28564&scoped=true"
import script from "./MyDatabaseGraph.vue?vue&type=script&lang=js"
export * from "./MyDatabaseGraph.vue?vue&type=script&lang=js"

import "./MyDatabaseGraph.vue?vue&type=style&index=0&id=cdb28564&scoped=true&lang=css"

import exportComponent from "/Users/guohongcheng/Documents/jeff/jeff_spn_mini/user_interface/web/vue/tianping/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdb28564"]])

export default __exports__